<div
	[attr.data-cy]="'dropdown-' + id"
	[attr.value]="_value()"
	(evasysClickAway)="onClickAway()"
	class="position-relative w-100"
>
	<ng-content></ng-content>
</div>
